export default __webpack_public_path__ + "static/media/welcome-banner-no-bee.fef40137.svg";